import collection from "./invoices/collection"
import invoice from "./invoices/invoice"

export default {
  namespaced: true,
  modules: {
    collection,
    invoice
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/earnings/invoices.js